import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { faCalendarDays } from '@fortawesome/pro-light-svg-icons/faCalendarDays';
import { TypedMemo } from '../../../../common/types';
import { useSMLRouter } from '../../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../../routing/sml/SMLRoutes';
import { useOpenSongPage } from '../../../../smartLinks/catalog/song/page/useOpenSongPage';
import { Panel } from '../../../components/primitives/Panel';
import { SMLEmptyState } from '../../../components/SMLEmptyState/SMLEmptyState';
import { SMLButton } from '../../../components/primitives/SMLButton';
import { planMessages } from './planMessages';

interface NoDatePanelProps {
  catalogItemUuid: string;
}

/**
 * A song with no release date (design f3): no rollout days and no gaps. "Set the date in Catalog"
 * opens the Details section of the Catalog song page; "Post now in Composer" opens the Composer.
 */
const NoDatePanelComponent: React.FC<NoDatePanelProps> = ({ catalogItemUuid }) => {
  const intl = useIntl();
  const router = useSMLRouter();
  const openSongPage = useOpenSongPage();
  const setDate = useCallback(() => openSongPage(catalogItemUuid, 'details'), [catalogItemUuid, openSongPage]);
  const openComposer = useCallback(() => router.push(SMLRoutes.promoteComposer), [router]);

  return (
    <Panel data-testid="plan-no-date">
      <SMLEmptyState
        icon={faCalendarDays}
        title={intl.formatMessage(planMessages.noDateTitle)}
        description={intl.formatMessage(planMessages.noDateBody)}
        action={{ label: intl.formatMessage(planMessages.noDateAction), onClick: setDate }}
      />
      <div className="d-flex justify-content-center pb-3">
        <SMLButton onClick={openComposer}>{intl.formatMessage(planMessages.postNow)}</SMLButton>
      </div>
    </Panel>
  );
};

export const NoDatePanel = TypedMemo(NoDatePanelComponent);
